<template>
  <div :class="`vertical-offset4 width-100 ${classes}`">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TrFooterButtonsContainer',
  props: {
    classes: {
      required: false,
      type: String,
      default: ''
    }
  }
};
</script>